var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"salesflow-btn salesflow-btn-outline",on:{"click":function($event){return _vm.$emit('click')}}},[_vm._v("\n  "+_vm._s(_vm.__('Convidar usuário'))+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }